module.exports = __webpack_public_path__ + "96ad752f5748bd6602290de13ab5cfe0.pdf";